<template>
  <div class="chartsCardCom ashComWrap">
    <div class="comTitle">
      <h4>{{ title }}</h4>
      <el-radio-group
        v-if="tabsList.length"
        v-model="activeKey"
        size="mini"
        @change="hanldeClick(title)"
      >
        <el-radio-button :label="v.value" v-for="(v, i) in tabsList" :key="i">
          {{ v.name }}
        </el-radio-button>
      </el-radio-group>
    </div>
    <div class="comContentBox">
      <PublicEcharts
        :id="id"
        :chartsData="chartsData"
        :type="'lightSwitchable'"
      />
    </div>
  </div>
</template>

<script>
import PublicEcharts from "@/components/PublicEcharts";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: String | Number,
      default: "publicCharts",
    },
    tabsList: {
      type: Array,
      default: () => [],
    },
    active: {
      type: String,
      default: "",
    },
    chartsData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    PublicEcharts,
  },
  data() {
    return {
      activeKey: this.active,
    };
  },
  methods: {
    hanldeClick(type) {
      this.$emit("getActiveItem", { type, active: this.activeKey });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.chartsCardCom {
  width: 100%;
  height: 100%;
}
</style>
